/* eslint-disable quote-props */
type ImmunisationTypeTypes = Record<string, string[]>;
type ImmunisationTypesMap = Record<string, ImmunisationTypeTypes>;
export const immunisationTypesAndOutcomes: ImmunisationTypesMap = {
    "Diphtheria / Tetanus / Polio (DTP)": {
        "DTP Vaccine": ["Given"]
    },
    "EPP Hepatitis B": {
        "EPP Hepatitis B Surface Antigen": ["Negative", "Positive"],
        "EPP Hepatitis B Viral Load": ["Detected", "Undetectable", "Not Detected"]
    },
    "EPP Hepatitis C": {
        "EPP Hepatitis C Antibodies": ["Negative", "Positive"],
        "EPP Hepatitis C Viral Load": ["Detected", "Undetectable", "Not Detected"]
    },
    "EPP HIV": {
        "EPP HIV Antibodies": ["Negative", "Positive"],
        "EPP HIV Viral Load": ["Detectable", "Not Detected", "Undetectable"]
    },
    "Hepatitis A": {
        "1st Hepatitis A Vaccine": ["Given"],
        "2nd Hepatitis A Vaccine": ["Given"]
    },
    "Hepatitis A & B Combined": {
        "1st Hepatitis A&B Combined Vaccine": ["Given"],
        "2nd Hepatitis A&B Combined Vaccine": ["Given"],
        "3rd Hepatitis A&B Combined Vaccine": ["Given"],
        "Immediate Hepatitis B Booster": ["Given"],
        "Standard Hepatitis B Booster": ["Given"],
        "Hepatitis B Surface Antibody (Immunity)": [
            "<10iu/ml – Not completed full course (Hep B)",
            "<10iu/ml - N/Imms Repeat (HepB)",
            "<10iu/ml - Non Responder (HepB)",
            "<10iu/ml - Old Course (HepB)",
            "<10iu/ml - Primary Course (HepB)",
            ">100iu/ml - Imm Boost in 12 Months (HepB)",
            ">100iu/ml - Imm Boost in 5 years (HepB)",
            ">100iu/ml - immune No Further Action",
            "10-100iu/ml -Immediate Booster (Hep B)",
        ],
        "Hepatitis B Core Antibody": ["Negative", "Positive"],
    },
    "Hepatitis B": {
        "1st Standard Hepatitis B Primary": ["Given"],
        "1st Standard Hepatitis B Secondary": ["Given"],
        "2nd Standard Hepatitis B Primary": ["Given"],
        "2nd Standard Hepatitis B Secondary": ["Given"],
        "3rd Standard Hepatitis B Primary": ["Given"],
        "3rd Standard Hepatitis B Secondary": ["Given"],
        "1st Accelerated Hepatitis B Primary": ["Given"],
        "1st Accelerated Hepatitis B Secondary": ["Given"],
        "2nd Accelerated Hepatitis B Primary": ["Given"],
        "2nd Accelerated Hepatitis B Secondary": ["Given"],
        "3rd Accelerated Hepatitis B Primary": ["Given"],
        "3rd Accelerated Hepatitis B Secondary": ["Given"],
        "4th Accelerated Hepatitis B": ["Given"],
        "Immediate Hepatitis B Booster": ["Given"],
        "Standard Hepatitis B Booster": ["Given"],
        "Hepatitis B Surface Antibody (Immunity)": [
            "<10iu/ml – Not completed full course (Hep B)",
            "<10iu/ml - N/Imms Repeat (HepB)",
            "<10iu/ml - Non Responder (HepB)",
            "<10iu/ml - Old Course (HepB)",
            "<10iu/ml - Primary Course (HepB)",
            ">100iu/ml - Imm Boost in 12 Months (HepB)",
            ">100iu/ml - Imm Boost in 5 years (HepB)",
            ">100iu/ml - immune No Further Action",
            "10-100iu/ml -Immediate Booster (Hep B)",
        ],
        "Hepatitis B Core Antibody": ["Negative", "Positive"],
        "Hepatitis B Surface Antigen": ["Negative", "Positive"],
    },
    "Measles Mumps & Rubella": {
        "1st MMR Vaccine": ["Given"],
        "2nd MMR Vaccine": ["Given"],
        "Single Measles Vaccine": ["Given"],
        "Single Rubella Vaccine": ["Given"],
        "Measles Antibody": [
            "Immune",
            "Non-Immune",
            "Equivocal",
            "Positive",
            "Negative",
        ],
        "Rubella Antibody": [
            "Immune",
            "Non-Immune",
            "Equivocal",
            "Positive",
            "Negative",
        ],
        "Mumps Antibody": [
            "Immune",
            "Non-Immune",
            "Equivocal",
            "Positive",
            "Negative",
        ],
    },
    "Non-EPP New to NHS Hepatitis B Check": {
        "Hepatitis B Surface Antigen": ["Negative", "Positive"],
    },
    "Non-EPP New to NHS Hepatitis C Check": {
        "Hepatitis C Antibodies": ["Negative", "Positive"],
    },
    "Non-EPP New to NHS HIV Check": {
        "HIV Antibodies": ["Negative", "Positive"],
    },
    "Pertussis": {
        "Pertussis Containing Vaccine": ["Given"]
    },
    "TB": {
        "BCG Scar Check": ["Visible", "Not Visible"],
        "Mantoux Result": ["0-5mm", ">5mm"],
        "BCG Vaccine": ["Given"],
        "IGRA Blood Test Result": ["Negative", "Positive", "Indeterminate"],
        "T-Spot Blood Test Result": ["Negative", "Positive", "Indeterminate"],
        "Quantiferon Blood Test Result": ["Negative", "Positive", "Indeterminate"],
        "Repeat IGRA Blood Test Result": ["Negative", "Positive", "Indeterminate"],
        "Repeat T-Spot Blood Test Result": ["Negative", "Positive", "Indeterminate"],
        "Repeat Quantiferon Blood Test Result": ["Negative", "Positive", "Indeterminate"],
        "Chest Clinic Referral Bloods": ["Completed"]
    },
    "Typhoid": {
        "Typhoid Vaccine": ["Given"]
    },
    "Varicella": {
        "Verbal History": [
            "History of previous infection in the UK",
            "No History of previous infection in the UK",
            "History of previous infection in temperate climate",
            "No History of previous infection in temperate climate"
        ],
        "Varicella Antibody": [
            "Immune",
            "Not Immune",
            "Positive",
            "Negative",
            "Equivocal"
        ],
        "1st Varicella Vaccine": ["Given"],
        "2nd Varicella Vaccine": ["Given"],

    },
    "Other": {}
};
